/*
|--------------------------------------------------------------------------
| Init
|--------------------------------------------------------------------------
*/

/**
 * Initializes the application. uses the site data array to set up the application and runs functions that are needed on all website pages.
 */
__gh__webApp.init = function() {
    console.log("GH Web App: Initializing...");
	// Set object to the window so it's available everywhere
	window.__gh__coreData 	= __gh__coreData;
    window.__gh__webApp 	= __gh__webApp;
    window._$ 				= _$;

    var commonJS	= __gh__webApp.common,
    	analytics 	= __gh__webApp.analytics,
		paywall		= __gh__webApp.paywall,
		siteData 	= __gh__coreData.siteData,
		siteForms	= __gh__webApp.siteForms,
		social		= __gh__webApp.social,
		utilities 	= __gh__webApp.utilities,
		video		= __gh__webApp.video,
		currentPage = __gh__webApp.currentPage,
		ads			= __gh__webApp.ads;



	__gh__webApp.modernizr.init();
	__gh__webApp.localStorage.init();

	//Site forms
	siteForms.searchForm.init();
	siteForms.newsletterForm.init();

	//Utilities
    utilities.lazyImages.init();
    utilities.fetch.handlebarsView.init();
    utilities.modal.init();
    utilities.accordion.init();
	utilities.fetch.html.init();
	analytics.salesforce.init();


	//Analytics
	if (commonJS.isObjectPropertySet(utilities,"tracker.init")){
		utilities.tracker.init();
	}
	analytics.krux.init();
	analytics.genesis.init();
    analytics.pingdom.init();
    analytics.chartbeat.init();


    //Paywall
    __gh__webApp.paywall = paywall[siteData.providers.paywall];
    __gh__webApp.paywall.init();


	__gh__webApp.buckets.init();


	//Ads should ONLY run if we're not on the article template
	//See article.js, line 180 for dynamic ad call for articles
	if(currentPage.isHome() || currentPage.isWrapper()){
		__gh__webApp.ads.init();
	}

	__gh__webApp.backToTop.init();
	analytics.parsely.init();

	//Load after page has loaded
	$(document).ready(function() {
		__gh__coreData.globalVariables.galPagerCounter = 0;
		__gh__coreData.globalVariables.galPagerCounterStatic = 0;
		__gh__coreData.globalVariables.galPagerCount = 3;
	     __gh__webApp.navigation.init();
	     utilities.weather.init();
	     utilities.promowiz.init();
	     social.addToAny.init();
	     __gh__webApp.navHandler.init();
	});

};
